import { render, staticRenderFns } from "./VerificationOtp.vue?vue&type=template&id=1267ec23&scoped=true"
import script from "./VerificationOtp.vue?vue&type=script&lang=js"
export * from "./VerificationOtp.vue?vue&type=script&lang=js"
import style0 from "./VerificationOtp.vue?vue&type=style&index=0&id=1267ec23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267ec23",
  null
  
)

export default component.exports